export default __webpack_public_path__ + "static/media/iStock-1226233033.986e3010.jpg";